module.exports = __webpack_public_path__ + "img/media-1.5e9feb78.png";